import { addSign } from '../constants';
import { useDice } from '../../../../providers/DiceProvider';


function getModString(modNumber) {
    let result = Math.floor((modNumber-10)/2);
    return addSign(result)
}

const SkillGridInput = ({total=false, value, diceRollType, cKey, edit, disabled = false, handleChange, style}) => {
    const { textRoll } = useDice()
    let isSave = cKey?.substring(cKey.length-4, cKey.length) === 'save'
    
    const validate = (e, send = false) => {
        const numberSignRegex = /^[\d+-]*$/;
        
        // if input is numbers - or +
        if(numberSignRegex.test(e.target.value)) {
            // default to 10 if the input is empty before sending
            if(send && e.target.value.length === 0) {
                // If input is empty on send/onBlur, set to 10 or 0 if a save
                e.target.value = isSave ? 0 : 10 
            }
            handleChange(e, cKey, undefined, undefined, send)
        }
    }

    if(disabled || handleChange === undefined) {
        return (
            <div className='statBlockSkillsInput' 
                style={{...style, fontWeight: total ? "light" : "bold"}} 
                onClick={() => { if(diceRollType && !edit) textRoll("1D20" + value, diceRollType) }} >
                    {value}
            </div>  
        )
        
    }

    return (
        <input className='statBlockSkillsInput' 
            disabled={disabled || handleChange === undefined}
            style={{...style, fontWeight: total ? "light" : "bold", width: '100%'}} 
            value={value} 
            onFocus={(e) => e.target.select()} 
            type='text' 
            onChange={e => validate(e)} 
            onBlur={e => validate(e, true)} 
            onClick={(event) => event.stopPropagation()} 
        />
    )
}

const changeName = window.location.search.includes('becca')

function getName(skillName) {
    if(!changeName) {
        return skillName
    } else {
        let skillKeys = {
            'STR': 'P.Att.',
            'DEX': 'P.Def.',
            'CON': 'M.Att.',
            'INT': 'M.Def.',
        }

        return skillKeys[skillName]

    }
}

const SkillGridItem = ({skillName, skillTotal, skillSave, edit, handleChange}) => {

    let totalStyle = edit ? {borderBottom: '3px dotted grey', cursor: 'text'} : {cursor: "default"}
    let modStyle = edit ? {borderBottom: 'none', cursor: 'default' } : {cursor: "pointer"}
    let saveStyle = edit ? {borderBottom: '3px dotted grey', cursor: 'text'} : {cursor: "pointer"}

    let skill = getName(skillName)
    const bigLetter = skill.charAt(0); // Gets the first letter
    const smallLetters = skill.slice(1); // Gets the rest of the string

    let skillKeys = {
        'STR':['strength', 'strength_save', "STR Check", "STR Save"],
        'DEX':['dexterity', 'dexterity_save', "DEX Check", "DEX Save"],
        'CON':['constitution', 'constitution_save', "CON Check", "CON Save"],
        'INT':['intelligence', 'intelligence_save', "INT Check", "INT Save"],
        'WIS':['wisdom', 'wisdom_save', "WIS Check", "WIS Save"],
        'CHA':['charisma', 'charisma_save', "CHA Check", "CHA Save"]
    }

    return (
        <>
            <div className="skillGridItem skillGridItemLabel skillSpaceLeft" style={{borderBottomLeftRadius: skillName === 'INT' ? '5px' : ''}}>
                <strong>{bigLetter}<span>{smallLetters}</span></strong>
            </div>
            <div className="skillGridItem">
                <SkillGridInput total={true} value={skillTotal} cKey={skillKeys[skillName][0]} handleChange={handleChange} edit={edit} disabled={!edit} style={totalStyle}/>
            </div>
            <div className="skillGridItem">
                <SkillGridInput value={getModString(skillTotal)} diceRollType={skillKeys[skillName][2]} edit={edit} disabled={true} style={modStyle}/>
            </div>
            {!changeName && 
                <div className="skillGridItem skillSpaceRight" style={{borderBottomRightRadius: skillKeys[skillName][1] === 'charisma_save' ? '5px' : ''}}>
                    <SkillGridInput value={addSign(skillSave)} diceRollType={skillKeys[skillName][3]} cKey={skillKeys[skillName][1]} handleChange={handleChange} edit={edit} disabled={!edit} style={saveStyle}/>
                </div>
            }
        </> 
  );
}

export default SkillGridItem;